import { createFileRoute } from '@tanstack/react-router'

import { AchReturnReasonsScreen } from './-components/ach-return-reasons-screen.tsx'

export const Route = createFileRoute('/ach/return-reasons')({
  component: AchReturnReasonsScreen
})
